import React from 'react';
import PropTypes from 'prop-types';
import modal from '~components/modal';
import { Warning as WarningIcon } from 'common/components/svgs';

@modal({ className: 'unpubilshed-modal' }, true)
export default class UnpubilshedModal extends React.Component {
  handleYesBtn = () => {
    this.props.updateUnpubilshed();
  };

  render() {
    return (
      <div className="unpubilshed-modal__content">
        <WarningIcon className="unpubilshed-modal__icon" />
        <span className="unpubilshed-modal__text">{this.props.text}</span>
        <button className="unpubilshed-modal__no-btn" onClick={this.props.onClose}>
          {this.props.t('cms.form.value.no')}
        </button>
        <button className="unpubilshed-modal__yes-btn" onClick={this.handleYesBtn}>
          {this.props.t('cms.form.value.yes')}
        </button>
      </div>
    );
  }
}

UnpubilshedModal.propTypes = {
  t: PropTypes.func.isRequired,
  updateUnpubilshed: PropTypes.func,
  onClose: PropTypes.func,
  text: PropTypes.string,
};

UnpubilshedModal.defaultProps = {
  updateUnpubilshed: () => {},
  onClose: () => {},
  text: '',
};
